import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreditToolsComponent } from './credit-tools.component';

const routes: Routes = [
  {
    path: '',
    component: CreditToolsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CreditToolsRoutingModule { }
